var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"scrollUp","title":"Scroll To Top"}},[_c('i',{staticClass:"fas fa-arrow-up"})])}]

export { render, staticRenderFns }